import React, { useContext, useEffect, useState } from 'react';
import { Link, Navigate, useNavigate, useLocation, Routes, useRoutes, useSearchParams, redirect, useParams } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
import Input from '../../../components/uielements/input';
import Checkbox from '../../../components/uielements/checkbox';
import Button from '../../../components/uielements/button';
import IntlMessages from '../../../components/utility/intlMessages';
import { v4 as uuid } from 'uuid';
import Alert from '@iso/components/Feedback/Alert';
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import SignInStyleWrapper from './SignIn.styles';
import { AppContext } from '../../../context/ContextProvider';
import Spin from '../../Feedback/Spin/Spin.styles';
import { AlertContext } from '../../../context/alertContext';
import { GoogleOutlined } from '@ant-design/icons';
import atmoslyLogo from '../../../assets/images/atmoslyLogoWhiteNew.svg';
import atmoslyMobileLogo from '../../../assets/images/atmoslyLogoMobile.svg';
import tryWithoutLoginIcon from '@iso/assets/images/tryWithoutLoginIcon.svg';
// import { Tooltip } from 'antd';
import { testimonialsData } from './TestimonialsData';
// import TooltipDesign from './TooltipDesign';
import { VCardWidgetWrapper } from '../../../containers/Widgets/vCard/vCardWidget.styles';
import googleLogo from '../../../assets/images/google.svg';
import githubLogo from '../../../assets/images/icon/github-logo.svg';
import bcrypt from 'bcryptjs';
import api from '../../../api';
import { PasswordValidator, formatErrors, isSuperUser } from '../../../context/helper';
import userpic from '@iso/assets/images/user1.png';
import eyeIcon from '@iso/assets/images/icon/eye-icon.svg';
import eyeCloseIcon from '@iso/assets/images/icon/eye-close-icon.svg';
import Box from '@iso/components/utility/box';
import { dummyProfileData } from '../../../context/tryWithoutLogin';
import { CustomModal } from '../../Dashboard/CustomComponents/PageLoader.style';
import SigninSignupCarousel from '../../../components/SigninSignupCarousel/SigninSignupCarousel';
import { Label } from '../../UsersCRUD/UsersCRUD.styles';

// const salt = bcrypt.genSalt(10);

let titleStyle = {
  marginBottom: "0",
  fontFamily: 'Poppins',
  color: "#132f44"
}

let subTitleStyle = {
  fontFamily: 'Nunito Sans'
}

const imgDiv = {
  width: "45px",
  height: "35px",
  display: "-webkit-inline-flex",
  display: "-ms-inline-flex",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  marginBottom: "35px",
  borderRadius: "50%",
  marginRight: "20px"
}

const imgStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover"
}

const marginBot = {
  position: 'fixed',
  opacity: '100%',
  transition: 'all 1s ease',
  top: "7vw",
  right: "0",
  zIndex: '1000',
  width: "25%",
  padding: '15px'
};

const fadeMarginBot = {
  position: 'fixed',
  opacity: '0',
  transition: 'all 1s ease',
  top: "7vw",
  right: "0",
  zIndex: '-1',
  width: "25%",
  padding: '15px'
};

const signinDes = {
  fontSize: "56px",
  fontFamily: "Poppins semibold",
  color: "white",
  marginBottom: "18px",
  fontWeight: "600"
};

const signinSubDes = {
  fontSize: "30px",
  fontFamily: "Nunito Sans",
  color: "white",
};

const leftDiv = {
  position: "flex-start",
  display: "flex",
  flexDirection: "column",
  zIndex: "100",
  marginLeft: "55px",
  height: "100%",
  justifyContent: "space-between",
  position: "relative",
  width: "55%"
};

/*const imgDiv = {
  width: "35px",
  height: "35px",
  display: "-webkit-inline-flex",
  display: "-ms-inline-flex",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  marginBottom: "35px",
  borderRadius: "50%",
  marginRight: "20px",
  "&:hover, &:focus'": {
    border: "2px solid white"
  }
}

const imgStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover"
}*/

export default function SignIn() {
  let navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isAuth, setIsAuth, setProfileData, checkRefreshSignup, setCheckRefreshSignup } = useContext(AppContext);
  // let ele = useRoutes([]);

  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [hidePassword, setHidePassword] = useState(false);
  const [toggleEyeIcon, setToggleEyeIcon] = useState(false);
  const [sweetAlertMessage, setSweetAlertMessage] = useState('');
  const [userLoginData, setUserLoginData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const { alertOptions, set_alertOptions } = useContext(AlertContext);
  /*const [isAlert, setIsAlert] = useState({
    status: false,
    type: "success",
    title: "Verification Successfull!",
    description: "Verification Successfull, Please Sign In",
  });*/
  const [loginError, setLoginError] = useState({
    status: '',
    msg: {
      email: '',
      password: "",
      others: ""
    }
  });

  // const dispatch = useDispatch();
  // const isLoggedIn = useSelector((state) => state.Auth.idToken);

  // const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
  // React.useEffect(() => {
  //   if (isLoggedIn) {
  //     setRedirectToReferrer(true);
  //   }
  // }, [isLoggedIn]);

  useEffect(() => {
    let authToken = localStorage.getItem("isAuth");
    console.log("authToken in signIn.js :", authToken);
    if (authToken) {
      navigate("/");
    }
  }, []);


  useEffect(() => {
    console.log('searchParams :', searchParams.get('active'));
    console.log('searchParams :', searchParams.get('msg'));
    // console.log('searchParams :', searchParams.get('force'));
    // setLoading(true);
    // console.log('searchParams :', searchParams.get('auth'));
    // console.log('location.state :', location.state);
    // if (location.state && location.state.from === "topbaruser" && checkRefreshSignup) {
    //   window.location.reload();  // reload to clear any other context
    //   setCheckRefreshSignup(false); // This should not be present in ClearContext in contextProvider 
    //   // console.log("checkRefreshSignup in signin :", checkRefreshSignup);
    // }
    // else if (searchParams.get('force') === "true" && checkRefreshSignup){
    //   // delete query params after use
    //   searchParams.delete('force');
    //   setSearchParams(searchParams);
    //   window.location.reload();  // reload to clear any other context
    //   setCheckRefreshSignup(false);  // This should not be present in ClearContext in contextProvider 
    //   // console.log("checkRefreshSignup in signin :", checkRefreshSignup);
    // }
    if (searchParams.get('active') === "true") {
      set_alertOptions(alertOptions => ({
        ...alertOptions,
        status: true,
        type: "success",
        message: "User Verified Successfully.",
        description: "User verified successfully, Please sign in to continue.",
      }));

      // opacity=0 after 10sec
      setTimeout(() => {
        set_alertOptions(alertOptions => ({
          ...alertOptions,
          status: false,
          type: "success",
          message: "User Verified Successfully.",
          description: "User verified successfully, Please sign in to continue.",
        }));
      }, 5 * 1000);

      // delete query params after use
      searchParams.delete('active');
      searchParams.delete('msg');
      setSearchParams(searchParams);
    }
    else if (searchParams.get('active') === "true" && searchParams.get('msg') != "success") {
      set_alertOptions(alertOptions => ({
        ...alertOptions,
        status: true,
        type: "success",
        message: "Email Already Verified.",
        description: "User is already verified. Please sign in to continue.",
      }));

      // opacity=0 after 10sec
      setTimeout(() => {
        set_alertOptions(alertOptions => ({
          ...alertOptions,
          status: false,
          type: "success",
          message: "Email Already Verified.",
          description: "User is already verified. Please sign in to continue.",
        }));
      }, 5 * 1000);

      // delete query params after use
      searchParams.delete('active');
      searchParams.delete('msg');
      setSearchParams(searchParams);
    }
    else if (location.state && location.state.from === "signup" && location.state.text === "signup success") {
      set_alertOptions(alertOptions => ({
        ...alertOptions,
        status: true,
        type: "success",
        message: "Please Verify Your Email!",
        description: "A mail with verification has been sent to your email. Please verify Email!",
      }));

      // opacity=0 after 10sec
      setTimeout(() => {
        set_alertOptions(alertOptions => ({
          ...alertOptions,
          status: false,
          type: "success",
          message: "Please Verify Your Email!",
          description: "A mail with verification has been sent to your email. Please verify Email!",
        }));
      }, 5 * 1000);
    }
    else if (location.state && location.state.from === "signup") {
      set_alertOptions(alertOptions => ({
        ...alertOptions,
        status: true,
        type: "success",
        message: "User Created Successfully.",
        description: "Please sign in to continue.",
      }));

      // opacity=0 after 10sec
      setTimeout(() => {
        set_alertOptions(alertOptions => ({
          ...alertOptions,
          status: false,
          type: "success",
          message: "User Created Successfully.",
          description: "Please sign in to continue.",
        }));
      }, 5 * 1000);
    }
    else if (location.state && location.state.from === "verifyemail") {
      set_alertOptions(alertOptions => ({
        status: true,
        type: "success",
        message: "Email Already Verified.",
        description: "User is already verified. Please sign in to continue.",
      }));

      // opacity=0 after 10sec
      setTimeout(() => {
        set_alertOptions(alertOptions => ({
          status: false,
          type: "success",
          message: "Email Already Verified.",
          description: "User is already verified. Please sign in to continue.",
        }));
      }, 5 * 1000);
    }
    // else if(searchParams.get('auth') === "failed"){
    //   set_alertOptions(alertOptions => ({
    //     status: true,
    //     type: "error",
    //     message: "Auth Token Expired!",
    //     description: "Auth token expired please signIn again.",
    //   }));

    //   // opacity=0 after 10sec
    //   setTimeout(() => {
    //     set_alertOptions(alertOptions => ({
    //       status: false,
    //       type: "error",
    //       message: "Auth Token Expired!",
    //       description: "Auth token expired please signIn again.",
    //     }));
    //   }, 5 * 1000);

    //   // delete query params after use
    //   searchParams.delete('auth');
    //   setSearchParams(searchParams);
    // }

    setHidePassword(false);
    setLoading(false);
  }, []);


  //signin with github
  useEffect(() => {
    console.log("SearchParams list: ", searchParams.get('code'));
    if (searchParams.get('code')) {
      let code = searchParams.get('code');
      setSearchParams({});
      setLoading(true);
      fetch(process.env.REACT_APP_API_URI + '/api/users/github_account/', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "github_code": code,
          "is_github_signup": true
        })
      }).then(async (res) => {
        let jsonData = await res.json();
        console.log('jsonData :', jsonData);
        if (jsonData.status) {
          setLoginError({
            status: false,
            msg: "Success"
          });

          setIsAuth(true);
          // store the authentication status in local storage or browser cookie
          localStorage.setItem("isAuth", jsonData.data.access);
          localStorage.setItem("refreshToken", jsonData.data.refresh);
          localStorage.setItem("iam", userLoginData.rememberMe);
          setCheckRefreshSignup(true);
          // callRefreshTokenListner();
          navigate('/', {
            state: { from: "signin" }
          });
          setLoading(false);
        }
        else {
          try {
            let err = formatErrors(jsonData.error_details);
            setLoginError({
              status: true,
              msg: { others: [err] }
            });
            setLoading(false);
          }
          catch {
            setLoginError({
              status: true,
              msg: { others: ["An Error occured while login. Please retry."] }
            });
            setLoading(false);
          }
        }
      }).catch((err) => {
        console.log('signup err :', err);
        setLoginError({
          status: true,
          msg: { others: ['An Error occured when signing up with github'] }
        });
        setLoading(false);
      })
        .finally(() => {
          setLoading(false);
        })
    }
  }, []);

  const handelRememberMe = (e) => {
    setUserLoginData({ ...userLoginData, rememberMe: e.target.checked });
  }

  const signUpUsingGoogle = (tokenResponse) => {
    setLoading(true);
    let payload = {
      token: tokenResponse.access_token
    }
    // signup using google
    fetch(process.env.REACT_APP_API_URI + "/api/users/google_account", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(async (res) => {
        let jsonData = await res.json();
        console.log('signup jsonData :', jsonData);
        if (jsonData.status) {
          setIsAuth(true);
          // callRefreshTokenListner();
          // store the authentication status in local storage or browser cookie
          localStorage.setItem("isAuth", jsonData.data.access);
          localStorage.setItem("refreshToken", jsonData.data.refresh);
          localStorage.setItem("iam", true);
          setCheckRefreshSignup(true);
          navigate('/', {
            state: { from: "signin" }
          });
        }
        else {
          let err = formatErrors(jsonData.error_details);
          console.log("err in signup :", err);
          setLoginError({
            status: true,
            msg: { others: [err] }
          });
        }
      })
      .catch((err) => {
        console.log('signup err :', err);
        setLoginError({
          status: true,
          msg: { others: ['An Error occured when signing up with google'] }
        });
      })
      .finally(() => {
        setLoading(false);
      })
  }

  const loginWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      signUpUsingGoogle(tokenResponse)
    },
    onError: (err) => console.log('Error :', err)
  });

  const handelLoginForm = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setLoginError({
      status: false,
      msg: ""
    });

    setUserLoginData({ ...userLoginData, [name]: value });
  }

  function handleLogin(e, token = false) {
    e.preventDefault();
    if (userLoginData.email) {
      userLoginData.email = userLoginData.email.trim();
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userLoginData.email)) {
      setLoginError({
        status: true,
        msg: { email: ["Invalid Email"] }
      });
    }
    else if (!PasswordValidator(userLoginData.password)) {
      setLoginError({
        status: true,
        msg: { password: ["Password should contain at least 1 alphabet, 1 capital letter, 1 special character and min 8 characters"] }
      });
    }
    else {
      setLoading(true);
      console.log("Password: ", userLoginData.password);
      fetch(process.env.REACT_APP_API_URI + "/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: userLoginData.email,
          // password: bcrypt.hashSync(userLoginData.password, process.env.REACT_APP_ATMOSLY_SALT),
          password: userLoginData.password,
          remember_me: userLoginData.rememberMe,
        })
      })
        .then(async (res) => {
          let jsonData = await res.json();
          console.log('jsonData :', jsonData);
          if (jsonData.status) {
            setLoginError({
              status: false,
              msg: "Success"
            });

            setIsAuth(true);
            // store the authentication status in local storage or browser cookie
            localStorage.setItem("isAuth", jsonData.data.access);
            localStorage.setItem("refreshToken", jsonData.data.refresh);
            localStorage.setItem("iam", userLoginData.rememberMe);
            setCheckRefreshSignup(true);
            // callRefreshTokenListner();
            navigate('/', {
              state: { from: "signin" }
            });
          }
          else {
            try {
              let err = formatErrors(jsonData.error_details);
              setLoginError({
                status: true,
                msg: { others: [err] }
              });
            }
            catch {
              setLoginError({
                status: true,
                msg: { others: ["An Error occured while login. Please retry."] }
              });
            }
          }
        })
        .catch((err) => {
          console.log('err :', err);
          setLoginError({
            status: true,
            msg: { others: ['Login Failed, Please Try Again!'] }
          });
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }

  const tryWithoutLogin = () => {
    setUserLoginData({
      ...userLoginData,
      email: 'guest.user@atmosly.com',
      password: 'guest@2024',
    });

    localStorage.setItem("isAuth", true);

    // let myDummyData = {
    //   id: "",
    //   firstName: "Guest",
    //   lastName: "User",
    //   email: "guest.user@atmosly.com",
    //   phone: "",
    //   organisation: "atmosly",
    //   roles: ["guest"],
    //   super: false,
    //   permissions: [
    //     // "Can change user",
    //     // "Can delete user",
    //     // "Can view user",
    //     // "Can invite user",
    //     "Can view dashboard",
    //     // "Can add role",
    //     // "Can change role",
    //     // "Can delete role",
    //     // "Can view role",
    //     // "Can assign role",
    //     // "Can delete cluster",
    //     "Can view cluster",
    //     // "Can create cluster",
    //     // "Can do security scan",
    //     // "Can integrate account",
    //     "Can view integrate account",
    //     // "Can delete integrate account",
    //     // "Can view notifications subscription",
    //     // "Can edit notifications subscription",
    //     // "Can integrate channel",
    //     "Can view integrated channel",
    //     // "Can add project",
    //     // "Can delete project",
    //     "Can view project",
    //     // "Can deploy project",
    //     // "Can delete environment",
    //     // "Can add pipeline",
    //     "Can view pipeline",
    //     // "Can manage marketplace",
    //     // "Can only create, update and delete marketplace repositories",
    //     // "Can view marketplace",
    //     // "Can view security scan"
    //   ]
    // }

    console.log("dummyProfileData :", dummyProfileData);
    localStorage.setItem('profile-data', JSON.stringify(dummyProfileData));
    setCheckRefreshSignup(true);
    setProfileData(dummyProfileData);
    isSuperUser();

    navigate('/', {
      state: { from: "signin" }
    });

  }

  const loginWithGithub = () => {
    window.open(`https://github.com/login/oauth/authorize?client_id=${process.env.REACT_APP_GITHUB_OAUTH_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_GOOGLE_REDIRECT_URI}/signin&scope=user:email,read:user`, '_self');
    // const params = new URLSearchParams(window.location.search);
    // console.log("Params: ", params);
  }
  // let { from } = location.state || { from: { pathname: '/' } };

  // if (redirectToReferrer) {
  //   return <Navigate to={from} />;
  // }
  return (
    // <Spin spinning={loading}>
    <>
      <CustomModal
        visible={loading}
        //onCancel={hideModal}
        footer={null}
        closable={false}
        centered
        maskClosable={false}
        style={{ border: "none", boxShadow: "none", zIndex: loading ? 1100 : -1 }}
      >
        <div style={{ textAlign: 'center', background: "transparent", border: "none" }}>
          <Spin size="large" />
        </div>
      </CustomModal>


      <SignInStyleWrapper className="isoSignInPage">
        <Alert
          message={alertOptions.message}
          description={alertOptions.description}
          type={alertOptions.type}
          showIcon
          style={alertOptions.status ? marginBot : fadeMarginBot}
        />
        <div className='left-content'>
          <div >
            <picture>
              <source srcSet={atmoslyMobileLogo} media='(max-width: 768px)'></source>
              <img srcSet={atmoslyLogo} style={{ height: "64px" }} className='atmoslyLogo' />
            </picture>
            <p className="atmoslyTitle">
              <IntlMessages id="page.signInComDescription" />
            </p>
            <p className="atmoslySubTitle">
              <IntlMessages id="page.signInComSubDescription" />
            </p>
            <SigninSignupCarousel />
          </div>
          {/* <div>
            <Box style={{ color: "black", height: "fit-content", borderRadius: "10px", width: "50%" }}>
              <p style={{ fontFamily: "Nunito Sans Regular", color: "#13536C", fontSize: "19px", color: "#132f44" }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </p>
              <div style={{ display: "flex", marginTop: "20px" }}>
                <div style={imgDiv}>
                  <img src={userpic} alt={"Jhon"} style={imgStyle} />
                </div>
                <Box title="Adam Smith"
                  subtitle="Developer"
                  titleStyle={titleStyle}
                  subTitleStyle={subTitleStyle}
                  style={{
                    padding: "0",
                    border: "0",
                    width: "100%",
                  }}
                >
                </Box>
              </div>
            </Box>
            <div style={{ display: "flex" }}>
              {
                testimonialsData.map((val, idx) => {
                  return (
                    <div>
                      <div className='imgDiv'>
                        <img className='imgStyle' src={val.image} alt={"Jhon"} />
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div> */}
        </div>
        <div className="isoLoginContentWrapper">
          <div className="isoLoginContent">
            <div className='topDiv'>
              <p className='titleStyle'><IntlMessages id="page.signInTitle" /></p>
              <p className='subTitleStyle'> <IntlMessages id="page.signInSubtitle" /> </p>
            </div>
            <div className="isoSignInForm">
              <form>
                <div className="isoInputWrapper">
                  <Label className='form-label'>Email</Label>
                  <Input
                    name="email"
                    size="large"
                    placeholder="Email"
                    autoComplete="true"
                    value={userLoginData.email}
                    onChange={handelLoginForm}
                    className="inputs"
                  />
                  {loginError.status && loginError.msg.email && <p className="isoHelperText">
                    <span>{loginError.msg.email[0]}</span>
                  </p>}
                </div>

                {hidePassword ? null : <div className="isoInputWrapper">
                  <Label className='form-label'>Password</Label>
                  <Input
                    name="password"
                    size="large"
                    type={toggleEyeIcon ? "text" : "password"}
                    placeholder="Password"
                    autoComplete="false"
                    value={userLoginData.password}
                    onChange={handelLoginForm}
                    style={{ fontSize: "13px" }}
                    onKeyDown={(event) => {
                      event.key === "Enter" && userLoginData.email !== "" && handleLogin(event);
                    }}
                    className="inputs"
                    suffix={<img src={toggleEyeIcon ? eyeIcon : eyeCloseIcon} alt="eye" style={{ cursor: "pointer" }} onClick={() => { setToggleEyeIcon(!toggleEyeIcon) }} />}
                  />

                  {loginError.status && loginError.msg.password && <p className="isoHelperText">
                    <span>{loginError.msg.password[0]}</span>
                  </p>}
                </div>}

                {hidePassword ? null : <div className="isoInputWrapper isoLeftRightComponent">
                  <Checkbox className="checkBox" checked={userLoginData.rememberMe} onChange={handelRememberMe} style={{ color: "#7C7C7C" }}>
                    <IntlMessages id="page.signInRememberMe" />
                  </Checkbox>
                  {/*<Button type="primary" onClick={handleLogin}>
                    <IntlMessages id="page.signInButton" />
                  </Button>*/}

                  {(typeof loginError.msg === 'object' && loginError.msg.others && loginError.msg.others[0] === 'Please verify your email first to login') ?
                    <Link to="/verifyemail" state={{ from: "signin", email: userLoginData.email }} className="isoForgotPass">
                      <IntlMessages id="page.verifyEmail" />
                    </Link>
                    :
                    <Link to="/forgotpassword" className="isoForgotPass" style={{ color: "#132F44" }}>
                      <IntlMessages id="page.signInForgotPass" />
                    </Link>
                  }
                </div>}

                {loginError.status && loginError.msg.others && <p className="isoHelperText">
                  <span>{loginError.msg.others[0]}</span>
                </p>}

              </form>

              <div className="isoInputWrapper isoOtherLogin">
                {/* Log In */}
                <Button type="primary" style={{ background: "#132F44", marginBottom: "0" }} onClick={handleLogin}>
                  <IntlMessages id="page.signInButton" />
                </Button>

                {/* Try Without Login */}
                <Button
                  type="primary"
                  className="btnGooglePlus"
                  id="btnTry"
                  onClick={tryWithoutLogin}
                  style={{ marginTop: "20px", marginBottom: "40px" }}
                >
                  <img src={tryWithoutLoginIcon} style={{
                    marginRight: "15px",
                    width: "18px",
                    height: "18px",
                  }} />
                  <IntlMessages id="page.tryWithoutLogin" />
                </Button>

                <div className='header__center'> Or continue with </div>

                <div className='otherSignin'>

                  {/* Sign In With google */}
                  <Button
                    type="primary"
                    className="btnGooglePlus"
                    onClick={loginWithGoogle}
                    style={{ marginTop: "" }}
                  >
                    <img src={googleLogo} />
                    <span><IntlMessages id="page.signInGooglePlus" /></span>
                  </Button>

                  <Button
                    type="primary"
                    className="btnGooglePlus"
                    onClick={loginWithGithub}
                  >
                    <img src={githubLogo} />
                    <span><IntlMessages id="page.signInGithub" /></span>
                  </Button>
                </div>
              </div>

              <div className="isoCenterComponent isoHelperWrapper">
                {hidePassword
                  ?
                  <Link to="/signin" onClick={() => setHidePassword(false)}>
                    <IntlMessages id="page.signInDifferentAccount" />
                  </Link>
                  :
                  <>
                    <span>
                      <IntlMessages id="page.signInCreateText" />
                      <Link to="/signup" style={{ color: "#132f44" }}>
                        <IntlMessages id="page.signInCreateAccount" />
                      </Link>
                    </span>
                  </>}
              </div>
            </div>
          </div>
        </div>
      </SignInStyleWrapper>
      {/* </Spin> */}
    </>
  );
}
